import {APP_ROUTES} from "../app";

export const NEWS_PAGE_LABELS = {
    LATEST_NEWS: 'Latest news',
    ALL_NEWS: 'All news',
} as const;

export const NEWS_PAGE_BREAD_CRUMB_CONTENT = {
    NEWS: {title: 'News', href: APP_ROUTES.NEWS},
};

export const FIRST_PAGE = '1';

export const CUSTOM_STYLED_MAP = {
    FONT_SIZE_18: {
        fontSize: "18px",
    },
    FONT_SIZE_16: {
        fontSize: "16px",
    },
    FONT_SIZE_24: {
        fontSize: "24px",
    },
};

export const INLINE_STYLES = {
    inlineStyles: {
        FONT_SIZE_18: { style: { fontSize: "18px" } },
        FONT_SIZE_16: { style: { fontSize: "16px" } },
        FONT_SIZE_24: { style: { fontSize: "24px" } },
    },
};

export const FONT_SIZE_STYLES = ["FONT_SIZE_16", "FONT_SIZE_18", "FONT_SIZE_24"];

export const TITLE_VALIDATE = {
    required: { value: true, message: 'The field is required for submission' },
    minLength: {value: 1, message: 'Minimum characters long'},
};